import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <Result
        status="404"
        title="Page not found"
        subTitle="The page you requested does not exist."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back home
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
